import React, { Component } from 'react';
import './MenuBar.css';
import { faCube, faHome, faBuilding} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MenuType from '../enums/MenuType';
import Slider from './Slider';	
import Star from './Star';
import InsertedMenuItemsHandler from '../ui_core/InsertedMenuItemsHandler';
import IconButton from './IconButton';
import ZoomButtons from './ZoomButtons';
import Urls from '../urls/Urls';
import DragDropStreetViewButton from './DragDropStreetViewButton';
import MenuBarWindowEntries from './MenuBarWindowEntries';
import AssetsManager from '../assets_management/AssetsManager';
import eventEnable from '../core/eventEnable';
import FullScreen from '../ui_core/FullScreen';
import Handles from '../core/Handles';
import Tutorials from '../tutorials/Tutorials';
import TutorialMessage from '../tutorials/TutorialMessage';
import isIphone from '../core/isIphone';
import UrlParameters from '../urls/UrlParameters';
import checkIfImageExists from '../core/checkIfImageExists';
export default class MenuBar extends Component {
	constructor(props){
		super(props);
		const {showMainMenu, onZoomChange, setFavouritesActive, zoomMin, zoomMax, showDefaultOutside360,
			getDragDropRecipientForStreetViewButton, showDefault3d, showBrochures, showPlots, showHouseTypes,
			showHouseGridSelector, playSiteVideo, showTwoDSitePlan, getConfiguration, showSuggestedSites,
			showSpecification,
			showLocalArea} = props;
		eventEnable(this);
		this._callbackShowSpecification =showSpecification;
		this._getConfiguration = getConfiguration;
		this._zoomMin=zoomMin;
		this._zoomMax = zoomMax;
		this._showHouseTypeGrid = UrlParameters.salesforce;
		this._mapMenuTypeToHandles = new Map();
		this._showMainMenu = showMainMenu;
		this._callbackShowPlots = showPlots;
		this._callbackShowDefaultOutside360 = showDefaultOutside360;
		this._callbackShowDefault3d = showDefault3d;
		this._callbackShowBrochures = showBrochures;
		this._callbackShowHouseTypes= showHouseTypes;
		this._callbackPlaySiteVideo= playSiteVideo;
		this._callbackShowTwoDSitePlan= showTwoDSitePlan;
		this._callbackShowSuggestedSites = showSuggestedSites;
		this._callbackShowHouseGridSelector = showHouseGridSelector;
		this._callbackShowLocalArea = showLocalArea;
		this._zoomButtonsRef=React.createRef();
		this._starRef=React.createRef();
		this._buttonSiteRef=React.createRef();
		this._callbackZoomChange = onZoomChange;
		this._setFavouritesActive=setFavouritesActive;
		this._getDragDropRecipientForStreetViewButton = getDragDropRecipientForStreetViewButton;
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this._handleClickButtonSite = this._handleClickButtonSite.bind(this);
		this._handleClickButton3d = this._handleClickButton3d.bind(this);
		this._handleClickButtonBrochures  = this._handleClickButtonBrochures .bind(this);
		this._handleSliderZoomValueChanged = this._handleSliderZoomValueChanged.bind(this);
		this.getHandlesActivateButton = this.getHandlesActivateButton.bind(this);
		this._handleClickButtonTwoDSitePlan = this._handleClickButtonTwoDSitePlan.bind(this);
		this._onStarSelectedChange = this._onStarSelectedChange.bind(this);
		this.setFavouritesActive = this.setFavouritesActive.bind(this);
		this._handleWindowResized= this._handleWindowResized.bind(this);
		this._handleClickButtonPlots= this._handleClickButtonPlots.bind(this);
		this._dispatchIsHorizontalChanged = this._dispatchIsHorizontalChanged.bind(this);
		this._menuTypeActiveChanged = this._menuTypeActiveChanged.bind(this);
		this._getIsPortrait = this._getIsPortrait.bind(this);
		this._handleClickButtonHouseTypes = this._handleClickButtonHouseTypes.bind(this);
		this._handleClickButtonSpecification = this._handleClickButtonSpecification.bind(this);
		this._handleClickButtonPlaySiteVideo = this._handleClickButtonPlaySiteVideo.bind(this);
		this._handleClickButtonSuggestedSites = this._handleClickButtonSuggestedSites.bind(this);
		this._handleClickButtonHelp = this._handleClickButtonHelp.bind(this);
		this._handleClickShowLocalArea = this._handleClickShowLocalArea.bind(this);
		this._updateTutorialMessages = this._updateTutorialMessages.bind(this);
		this._iMenuManager  = null;
		this._elementRef = React.createRef();
		this._windowEntriesRef = React.createRef();
		this._dragDropStreetViewButtonRef = React.createRef();
		const isHorizontal = this._getIsPortrait();
		this.state = {visible:false, horizontal:isHorizontal, insertedMenuItems:[], insertedMenuItemsAtEnd:[]};
		this._insertedMenuItemsHandler = new InsertedMenuItemsHandler(()=>this.state.insertedMenuItems, (insertedMenuItems)=>this.setState({insertedMenuItems:insertedMenuItems}));
		this._insertedMenuItemsAtEndHandler = new InsertedMenuItemsHandler(()=>this.state.insertedMenuItemsAtEnd, (insertedMenuItemsAtEnd)=>this.setState({insertedMenuItemsAtEnd:insertedMenuItemsAtEnd}));
		if(getConfiguration().hideBrochuresIconTillCustomerGeneratesBrochure){
			document.body.classList.add('hide-brochures-icon-till-customer-generates-brochure');
		}
		window.addEventListener('resize', this._handleWindowResized);
		setTimeout(()=>this._dispatchIsHorizontalChanged(isHorizontal), 0);
		Tutorials.addEventListener('update', this._updateTutorialMessages);
	}
	componentDidMount(){
		this._menuBarWindowEntries = new MenuBarWindowEntries({element:this._windowEntriesRef.current});
		checkIfImageExists(Urls.assets+'specification.png', (exists)=>{
			if(exists)
				this._elementRef.current?.classList.add('has-specification');
		});
	}
	getHandlesActivateButton(menuType){
		let handles =  this._mapMenuTypeToHandles.get(menuType);
		if(!handles) {
			handles = new Handles();
			this._mapMenuTypeToHandles.set(menuType, handles);
			handles.addEventListener('change', (e)=>{
				this._menuTypeActiveChanged(menuType, e.hasHandles);
			});
		}
		return handles;
	}
	_menuTypeActiveChanged(menuType, isActive){
		const className = menuType.toLowerCase()+'-active';
		const element = this._elementRef.current;
		if(isActive)element.classList.add(className);
		else element.classList.remove(className);
	}
	_getIsPortrait(){
		return (document.documentElement.clientHeight/document.documentElement.clientWidth)>1;
	}
	get insertedMenuItemsHandler(){
		return this._insertedMenuItemsHandler;
	}
	get insertedMenuItemsAtEndHandler(){
		return this._insertedMenuItemsAtEndHandler;
	}
	setFavouritesActive(active){
		this._starRef.current.selected=active;
	}
	show(){
		this.setState({visible:true});
	}
	hide(){
		this.setState({visible:false});
	}
	_handleWindowResized(){
		const isHorizontal = this._getIsPortrait();
		const changed = this.state.horizontal!==isHorizontal;
		this._setHorizontal(isHorizontal);
		//if(changed)
			this._dispatchIsHorizontalChanged(isHorizontal);
	}
	_dispatchIsHorizontalChanged(isHorizontal){
		this.dispatchEvent({type:'isHorizontalChanged', isHorizontal:isHorizontal});
	}
	_setHorizontal(horizontal){
		this.setState({horizontal:horizontal});
	}
	setZoom(value){
		this._zoomButtonsRef.current.setValue(value);
	}
	setIMenuManager(value){
		this._iMenuManager = value;
	}
	get menuType(){
		return MenuType.MENU_BAR;
	}
	_handleClickButtonSite(){
		Tutorials.hasClickedFilter=true;
		this._tutorialMessageFilter?.dispose();
		this._showMainMenu();
	}
	_handleSliderZoomValueChanged(value){
		this._callbackZoomChange(value);
	}
	_handleClickButtonFullscreen(){
		FullScreen.toggle(document.documentElement);
	}
	_handleClickButton3d(){
		this._callbackShowDefault3d();
	}
	_handleClickButtonBrochures(){
		this._callbackShowBrochures();
	}
	_handleClickButtonPlots(){
		this._callbackShowPlots();
	}
	_handleClickButtonHouseTypes(){
		if(this._showHouseTypeGrid)
			this._callbackShowHouseGridSelector();
		else
			this._callbackShowHouseTypes();
	}
	_handleClickButtonSpecification(){
		this._callbackShowSpecification();
	}
	_handleClickShowLocalArea(){
		this._callbackShowLocalArea();
	}
	_handleClickButtonPlaySiteVideo(){
		this._callbackPlaySiteVideo();
	}
	_handleClickButtonTwoDSitePlan(){
		this._callbackShowTwoDSitePlan();
	}
	_handleClickButtonSuggestedSites(){
		this._callbackShowSuggestedSites();
	}
	_handleClickButtonHelp(){
		Tutorials.generalWalkthrough();
	}
	_onStarSelectedChange(selected){
		Tutorials.hasClickedFavourites=true;
		this._tutorialMessageFavourite?.dispose();
		this._setFavouritesActive(selected);
	}/*
				<button className="button-site" onClick={this._handleClickButtonSite}>
					<div className="wrapper">
						<FontAwesomeIcon className="icon-1" icon={faHome}></FontAwesomeIcon>
						<FontAwesomeIcon className="icon-2" icon={faHome}></FontAwesomeIcon>
						<FontAwesomeIcon className="icon-3" icon={faBuilding}></FontAwesomeIcon>
					</div>
				</button>*/
	_updateTutorialMessages(){
				
		this._tutorialMessageOutside360?.dispose();
		this._tutorialMessageFavourite?.dispose();
		setTimeout(()=>{
			this._tutorialMessageOutside360?.dispose();
			this._tutorialMessageFilter?.dispose();
			this._tutorialMessageFavourite?.dispose();
			if(Tutorials.showStep4&&this._starRef.current&&Tutorials.showing&&!Tutorials.hasClickedFavourites){
				this._tutorialMessageFavourite = new TutorialMessage({
					message:'View favourites', elementOn:this._starRef.current._elementRef.current, 
					className:'tutorial-message-view-favourites',
					hasClose:true, callbackClose:()=>{
						Tutorials.showing = false;
					},
					fixInPlace:true
				});
				Tutorials.addShowingTutorialMessage(this._tutorialMessageFavourite);
			}
			if(this._buttonSiteRef.current&&Tutorials.showing&&!Tutorials.hasClickedFilter){
				this._tutorialMessageFilter = new TutorialMessage({
					message:'Filter plots', elementOn:this._buttonSiteRef.current._elementRef.current, 
					className:'tutorial-message-filter',
					hasClose:true, callbackClose:()=>{
						Tutorials.showing = false;
					},
					fixInPlace:true
				});
				Tutorials.addShowingTutorialMessage(this._tutorialMessageFilter);
			}
			if(Tutorials.showStep6&&this._dragDropStreetViewButtonRef.current&&Tutorials.showing&&!Tutorials.haveBeenToOutside360){
				this._tutorialMessageOutside360 = new TutorialMessage({
					message:'Click here or drag drop to walk around site!',
					className:'tutorial-message-menu-bar-outside-360',
					elementOn:this._dragDropStreetViewButtonRef.current._elementRef.current, 
					hasClose:true, callbackClose:()=>{
						Tutorials.showing = false;
					},
					fixInPlace:true
				});
				Tutorials.addShowingTutorialMessage(this._tutorialMessageOutside360);
			}
			
		});
	}
	render() {
		const configuration = this._getConfiguration();
		let className = "menu-bar"+(this.state.horizontal?' horizontal':'');
		if(this.state.visible)
			className+=" visible";
		this._updateTutorialMessages();
		
		let iconButtonFullScreen;
		if(isIphone){
				const urlParams = new URLSearchParams(window.location.search);
			if(urlParams.get('fullscreen'))
				iconButtonFullScreen = null;
			else
				iconButtonFullScreen=(<a href={`${window.location.href}?fullscreen=true`} target="_blank" className="button-fullscreen"><div className="inner"><div className="icon"><img src={Urls.assets+'icons/UI_Fullscreen.png'}></img></div></div></a>);
		}
		else
			iconButtonFullScreen = (FullScreen.isSupported?(<IconButton className="button-fullscreen" tooltip="Full Screen" imgUrl={Urls.assets+'icons/UI_Fullscreen.png'} text="" onClick={this._handleClickButtonFullscreen}></IconButton>
				):null);
				const buttonPlots = configuration.plotSelectionMenuEnabled?(<IconButton className="button-plots" tooltip="Plot list & availability" imgUrl={Urls.assets+'icons/UI_Button_Plots.png'}  onClick={this._handleClickButtonPlots}></IconButton>):null;
		const playSiteVideoButton = configuration.siteVideoEnabled?(<IconButton className="button-play-site-video" tooltip="Play Site Video" imgUrl={Urls.assets+'icons/UI_Button_Play.png'}  onClick={this._handleClickButtonPlaySiteVideo}></IconButton>):null;
		const brochureMenu = configuration.brochuresMenuEnabled?(<IconButton className="button-brochures" tooltip="Downloaded brochures" imgUrl={Urls.assets+'icons/brochures.png'}  onClick={this._handleClickButtonBrochures}></IconButton>):null;
		const twoDSitePlanButton = configuration.twoDSitePlanEnabled?(<IconButton className="button-2d-site-plan" tooltip="2D Site Plan" imgUrl={Urls.assets+'icons/UI_Button_Site.png'}  onClick={this._handleClickButtonTwoDSitePlan}></IconButton>):null;
		const suggestedSitesButton = AssetsManager.configuration.suggestedSitesEnabled?(<IconButton className="button-suggested-sites" tooltip="Sites" imgUrl={Urls.assets+'icons/UI_Button_Idea.png'}  onClick={this._handleClickButtonSuggestedSites}></IconButton>):null;
		const specificationButton = (
				<IconButton className="button-specification" tooltip="House Types"
					imgUrl={Urls.assets+'icons/UI_Button_Specification.png'}  onClick={this._handleClickButtonSpecification}></IconButton>);
		const buttonHouseTypes = configuration.houseTypesViewerEnabled||this._showHouseTypeGrid?(
				<IconButton className="button-house-types" tooltip="House Types"
					imgUrl={this._showHouseTypeGrid?(Urls.assets+'icons/UI_Button_House_Types.png')
					:(Urls.assets+'icons/UI_Button_House_Types.png')}  onClick={this._handleClickButtonHouseTypes}></IconButton>):null;
		const localAreaButton = this._showHouseTypeGrid?(<IconButton className="button-local-area" tooltip="Local Area" imgUrl={Urls.assets+'icons/LocalArea.png'}  onClick={this._handleClickShowLocalArea}></IconButton>):null;
		const dragDropStreetViewButton = configuration.outside360Enabled?(<DragDropStreetViewButton ref={this._dragDropStreetViewButtonRef}
				showDefaultOutside360={this._callbackShowDefaultOutside360} 
				getDragDropRecipient={this._getDragDropRecipientForStreetViewButton}/>):null;
		
				const buttonHelp = configuration.helpButtonEnabled?(<IconButton className="button-help" tooltip="Help Tutorial" imgUrl={Urls.assets+'icons/Help.png'} text="" onClick={this._handleClickButtonHelp}></IconButton>):null;
				return (
			<div className={className} ref={this._elementRef}>
				{iconButtonFullScreen}
					{buttonHelp}
				<IconButton className="button-site" ref={this._buttonSiteRef} tooltip="Menu" imgUrl={Urls.assets+'icons/UI_Button_Filter.png'} text="" onClick={this._handleClickButtonSite}></IconButton>
					{suggestedSitesButton}
						{specificationButton}
						{buttonHouseTypes}
							{buttonPlots}
					{playSiteVideoButton}
					{twoDSitePlanButton}
						{localAreaButton}
				<IconButton className="button-3d" tooltip="3D Site Plan" imgUrl={Urls.assets+'icons/3d.png'}  onClick={this._handleClickButton3d}></IconButton>
					{brochureMenu}
					
				<div className="inserted">{this.state.insertedMenuItems}</div>		
				<Star ref={this._starRef} tooltip="Favourite Plots" onSelectedChange={this._onStarSelectedChange}/>		
				<div className="window-entries" ref={this._windowEntriesRef}></div>
				<div className="filler"/>
				{dragDropStreetViewButton}
				<ZoomButtons ref={this._zoomButtonsRef}  min={this._zoomMin} max={this._zoomMax} interval={1} initial={this._zoomMin} 
					onValueChanged={this._handleSliderZoomValueChanged}/>
				<div className="inserted-at-end">{this.state.insertedMenuItemsAtEnd}</div>
			</div>
		)
	}
}